var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#add_icon_svg__b)",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.6 14.4h4a1.6 1.6 0 1 1 0 3.2h-4v4a1.6 1.6 0 0 1-3.2 0v-4h-4a1.6 1.6 0 0 1 0-3.2h4v-4a1.6 1.6 0 0 1 3.2 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_icon_svg__b",
    x1: 16,
    x2: 16,
    y1: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07818C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D3E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "add_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgAddIcon;